import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const categoryApi = createApi({
    reducerPath: 'categoryApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Catalog"],
    endpoints: (builder) => ({
        getCategory: builder.query({
            query: () => `categoryList`,
            providesTags: ["Catalog"],
        }),
        addCatalog: builder.mutation({
            query: (newCatalog) => ({
                url: 'catalog',
                method: 'POST',
                body: newCatalog,
            }),
            invalidatesTags: ['Catalog'],
        }),
        deleteCatalog: builder.mutation({
            query: ({ id }) => ({
                url: `catalog/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Catalog'],
        }),
    }),
})

export const { useGetCategoryQuery, useAddCatalogMutation, useDeleteCatalogMutation } = categoryApi